import { render, staticRenderFns } from "./EmploymentList.vue?vue&type=template&id=b261fd42&"
import script from "./EmploymentList.vue?vue&type=script&lang=ts&"
export * from "./EmploymentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports